export const CUSTOMIZABLE_TAG = 'Customizable'
export const READY_TO_SHIP_TAG = 'Ready to ship'
export const COMING_SOON_TAG = 'Coming Soon'
export const PLUS_PRODUCT_TYPE = 'Plus'
